jQuery(document).ready(function ($) {
  var $isotopeGrid = $('.ctn-properties').isotope({
    itemSelector: '.ctn-item',
    layoutMode: 'fitRows',
    filter: '*',
  });

  $isotopeGrid.imagesLoaded().progress(function () {
    $isotopeGrid.isotope('layout');
  });

  /* Filter für Grundrisse */
  $.fn.grundrissfilter = function () {
    var filterneu = '.' + this.attr('id').substring(17);
    console.log(filterneu);
    $isotopeGrid.isotope({
      filter: filterneu,
    });
  };

  $.fn.setActive = function () {
    $('.ctn-properties-filter .button').removeClass('is-active');
    $(this).addClass('is-active');
  };

  $('[id^=filter-]').click(function (event) {
    event.preventDefault();
    $(this).grundrissfilter();
    $(this).setActive();
  });

  $('#filter-grundriss-ohne').click(function (event) {
    event.preventDefault();
    $isotopeGrid.isotope({
      filter: '*',
    });
    $(this).setActive();
  });
});
